<template>
  <div class="separator"></div>
</template>
<style scoped lang="scss">
.separator {
  border-bottom: solid 1px var(--stm-control-border-color);
}
</style>